/**
 * Dizilmiş etiketleri sayfa sayfa çizer.
 *
 * Aynı bileşen hem ekran önizlemesinde (ölçekli) hem yazdırmada (ölçek 1,
 * sayfa sonu kesmeleriyle) kullanılır — böylece önizleme ile çıktı ayrışmaz.
 */

import React from 'react';
import { Box } from '@mui/material';
import { LabelTemplate } from '../../../types/labelTemplate.types';
import { LabelPage } from '../utils/labelImposition';
import LabelHtmlRenderer from './LabelHtmlRenderer';

export interface LabelSheetPreviewProps {
  template: LabelTemplate;
  pages: LabelPage[];
  /** Ekran ölçeği; yazdırmada 1 olmalı */
  scale?: number;
  /** Verilirse yalnızca o sayfa çizilir (ekran önizlemesi) */
  onlyPageIndex?: number;
  /** true: tüm sayfalar sayfa sonu kesmeleriyle (yazdırma) */
  forPrint?: boolean;
  /** Etiket sınırlarını kesikli göster */
  showBounds?: boolean;
}

const LabelSheetPreview: React.FC<LabelSheetPreviewProps> = ({
  template,
  pages,
  scale = 1,
  onlyPageIndex,
  forPrint = false,
  showBounds = false,
}) => {
  const visible = onlyPageIndex !== undefined ? pages.filter((p) => p.index === onlyPageIndex) : pages;

  return (
    <>
      {visible.map((page, i) => (
        <Box
          key={page.index}
          className="label-print-page"
          sx={{
            width: `${page.widthMm}mm`,
            height: `${page.heightMm}mm`,
            position: 'relative',
            backgroundColor: '#ffffff',
            overflow: 'hidden',
            flexShrink: 0,
            // Ekranda sayfa hissi; baskıda gölge/çerçeve olmamalı
            ...(forPrint
              ? {
                  breakAfter: i === visible.length - 1 ? 'auto' : 'page',
                  pageBreakAfter: i === visible.length - 1 ? 'auto' : 'always',
                }
              : {
                  boxShadow: '0 2px 12px rgba(0,0,0,0.18)',
                  outline: '1px solid #cfd8dc',
                }),
            transform: scale !== 1 ? `scale(${scale})` : undefined,
            transformOrigin: 'left top',
          }}
        >
          {page.labels.map((placed) => (
            <Box
              key={placed.instance.id}
              sx={{
                position: 'absolute',
                left: `${placed.xMm}mm`,
                top: `${placed.yMm}mm`,
              }}
            >
              <LabelHtmlRenderer template={template} data={placed.instance.data} showBounds={showBounds} />
            </Box>
          ))}
        </Box>
      ))}
    </>
  );
};

export default LabelSheetPreview;
